/* =========================================================
   New Promotional Banners – scroll/drag behaviour
   Scoped to [data-npb-track] so it never touches other sections.
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  var tracks = document.querySelectorAll('[data-npb-track]');

  tracks.forEach(function (track) {
    var wrapper = track.closest('.npb-track-wrapper');
    if (!wrapper) return;

    var prevBtn = wrapper.querySelector('[data-npb-prev]');
    var nextBtn = wrapper.querySelector('[data-npb-next]');

    function getScrollStep() {
      var card = track.querySelector('.npb-card');
      if (!card) return 300;
      var styles = window.getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || '24', 10) || 24;
      return card.getBoundingClientRect().width + gap;
    }

    /* Show/hide arrows based on how far the track has scrolled:
       left arrow only appears once you've scrolled away from the
       start, right arrow hides once you've reached the end. */
    function updateArrowVisibility() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;

      if (prevBtn) prevBtn.classList.toggle('npb-nav-hidden', atStart);
      if (nextBtn) nextBtn.classList.toggle('npb-nav-hidden', atEnd || maxScroll <= 2);
    }

    updateArrowVisibility();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    /* Mouse drag-to-scroll (desktop convenience, doesn't affect touch) */
    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('npb-dragging');
      startX = e.pageX - track.offsetLeft;
      startScroll = track.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
        track.classList.remove('npb-dragging');
      });
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = startScroll - walk;
    });
  });
});